import Login from "@/components/Login";
import Approval from "@/components/S010000-Approval";
import Outdoorwork from "@/components/S010100-Outdoorwork";
import LeaveApplication from "@/components/S030000-LeaveApplication";

//S040000
import StaffLeaveRecord from "@/components/S040000-Report/S040100-StaffLeaveRecord";
import StaffAttendance from "@/components/S040000-Report/S040200-StaffAttendance";
import OutdoorworkAllowance from "@/components/S040000-Report/S040400-OutdoorworkAllowance";
import TaxReturn from "@/components/S040000-Report/S040500-TaxReturn";
import MonthlyLeaveBalance from "@/components/S040000-Report/S040300-MonthlyLeaveBalance";

//S050000
import LeaveType from "@/components/S050000-MM/S050100-LeaveType";
import StaffGrading from "@/components/S050000-MM/S050200-StaffGrading";
import Annualleaveplan from "@/components/S050000-MM/S050300-AnnualLeavePlan";
import Worktype from "@/components/S050000-MM/S050400-WorkType";
import Holiday from "@/components/S050000-MM/S050500-Holiday";
import ShiftType from "@/components/S050000-MM/S050600-ShiftType";
import Roster from "@/components/S050000-MM/S050700-Roster";
import Location from "@/components/S050000-MM/S050800-Location";
import RosterPlan from "@/components/S050000-MM/S050900-RosterPlan";
// import AutopayFile from "@/components/S050000-MM/S051000-AutopayFile";

//S060000
import UserList from "@/components/S060000-Admin/S060100-UserList";
import UserGroup from "@/components/S060000-Admin/S060200-UserGroup";
import UserGroupRights from "@/components/S060000-Admin/S060300-UserGroupRights";
import SyncUserToMizar from "@/components/S060000-Admin/S060400-SyncUserToMizar";
//S070000
import EmployeeList from "@/components/S070000-Employee/S070100-Employee.vue";
//S080000
import SetupPage from "@/components/S080000-Setup/S080000-Setup";
//S090000
import JobAds from "@/components/S090000-Candidate/S090100-Job/S090100-Job.vue";
import InviteNewCandidate from "@/components/S090000-Candidate/S090200-InviteNewCandidate/S090200-InviteNewCandidate.vue";
import VerifyCandidate from "@/components/S090000-Candidate/VerifyCandidate/VerifyCandidate.vue";
import JobApplicationForm from "@/components/S090000-Candidate/S090300-JobApplicationForm/S090300-JobApplicationForm.vue";
import JobApplication from "@/components/S090000-Candidate/S090300-JobApplication/S090300-JobApplication.vue";
import CandidateJobApplicationForm from "@/components/S090000-Candidate/S090300-JobApplicationForm/S090300-CandidateJobApplicationForm.vue";
import JobInterviewStart from "@/components/S090000-Candidate/S090300-JobInterviewStart/S090300-JobInterviewStart.vue";
import CandidateJobInterviewStart from "@/components/S090000-Candidate/S090300-JobInterviewStart/S090300-CandidateJobInterviewStart.vue";
import Enquiry from "@/components/S090000-Candidate/S090400-Enquiry/S090400-Enquiry.vue";

//S100000
import Calendar from "@/components/S100000-Calendar/S100100-Calendar";

//S110000
import InterviewSchedule from "@/components/S110000-InterviewSchedule/S110100-InterviewScheduleOld";
//import InterviewSchedule from "@/components/S110000-InterviewSchedule/S110101-InterviewScheduleNew";
import InterviewScheduleNew from "@/components/S110000-InterviewSchedule/S110000-InterviewSchedule.vue";
import PayrollTrial from "@/components/100000-Payroll/101000-PayrollTrial/101000-PayrollTrial.vue";
import SpecialPayment from "@/components/100000-Payroll/102000-SpecialPayment/102000-SpecialPayment.vue";
import PayrollAdjustment from "@/components/100000-Payroll/103000-PayrollAdjustment/103000-PayrollAdjustment.vue";
import PayrollApproval from "@/components/100000-Payroll/104000-PayrollApproval/104000-PayrollApproval.vue";
import FinalPayment from "@/components/100000-Payroll/105000-FinalPayment/105000-FinalPayment.vue";
import PayProfile from "@/components/100000-Payroll/106000-PayProfile/106000-PayProfile.vue";
import Router from "vue-router";
import StoreGetter from "@/constants/StoreGetter";
import { store } from "@/store";
import Settings from "@/constants/Settings";

let router = new Router({
  mode: "history",
  hashbang: false,
  transitionOnLoad: true,
  linkActiveClass: "active",
  routes: [
    {
      path: "/",
      redirect: {
        name: "Login"
      }
    },
    {
      path: "/login/:action",
      name: "Login",
      component: Login,
      meta: { loginauth: true }
    },
    {
      path: "/approval",
      name: "Approval",
      component: Approval,
      meta: {
        requiresAuth: true,
        menuId: "010000"
      }
    },
    {
      path: "/leaveType",
      name: "LeaveType",
      component: LeaveType,
      meta: {
        requiresAuth: true,
        menuId: "050100"
      }
    },
    {
      path: "/staffGrading",
      name: "StaffGrading",
      component: StaffGrading,
      meta: {
        requiresAuth: true,
        menuId: "050200"
      }
    },
    {
      path: "/holiday",
      name: "Holiday",
      component: Holiday,
      meta: {
        requiresAuth: true,
        menuId: "050500"
      }
    },
    {
      path: "/workType",
      name: "Worktype",
      component: Worktype,
      meta: {
        requiresAuth: true,
        menuId: "050400"
      }
    },
    {
      path: "/shiftType",
      name: "ShiftType",
      component: ShiftType,
      meta: {
        requiresAuth: true,
        menuId: "050600"
      }
    },
    {
      path: "/roster",
      name: "Roster",
      component: Roster,
      meta: {
        requiresAuth: true,
        menuId: "050700"
      }
    },
    {
      path: "/location",
      name: "Location",
      component: Location,
      meta: {
        requiresAuth: true,
        menuId: "050800"
      }
    },
    {
      path: "/rosterPlan",
      name: "RosterPlan",
      component: RosterPlan,
      meta: {
        requiresAuth: true,
        menuId: "050900"
      }
    },
    // {
    //   path: "/autopayFile",
    //   name: "AutopayFile",
    //   component: AutopayFile,
    //   meta: {
    //     requiresAuth: true,
    //     menuId: "051000"
    //   }
    // },
    {
      path: "/annualLeavePlan",
      name: "Annualleaveplan",
      component: Annualleaveplan,
      meta: {
        requiresAuth: true,
        menuId: "050300"
      }
    },
    {
      path: "/userGroup",
      name: "UserGroup",
      component: UserGroup,
      meta: {
        requiresAuth: true,
        menuId: "060200"
      }
    },
    {
      path: "/outdoorwork",
      name: "Outdoorwork",
      component: Outdoorwork,
      meta: {
        requiresAuth: true,
        menuId: "010100"
      }
    },
    {
      path: "/leaveapplication",
      name: "LeaveApplication",
      component: LeaveApplication,
      meta: {
        requiresAuth: true,
        menuId: "030000"
      }
    },
    {
      path: "/userList",
      name: "UserList",
      component: UserList,
      meta: {
        requiresAuth: true,
        menuId: "060100"
      }
    },
    {
      path: "/usergrouprights",
      name: "UserGroupRights",
      component: UserGroupRights,
      meta: {
        requiresAuth: true,
        menuId: "060300"
      }
    },
    {
      path: "/syncUserToMizar",
      name: "SyncUserToMizar",
      component: SyncUserToMizar,
      meta: {
        requiresAuth: true,
        menuId: "060400"
      }
    },
    {
      path: "/staffAttendance",
      name: "StaffAttendance",
      component: StaffAttendance,
      meta: {
        requiresAuth: true,
        menuId: "040200"
      }
    },

    {
      path: "/staffLeaveRecord",
      name: "StaffLeaveRecord",
      component: StaffLeaveRecord,
      meta: {
        requiresAuth: true,
        menuId: "040100"
      }
    },
    {
      path: "/outdoorWorkAllowance",
      name: "OutdoorworlAllowance",
      component: OutdoorworkAllowance,
      meta: {
        requiresAuth: true,
        menuId: "040400"
      }
    },
    {
      path: "/taxReturn",
      name: "TaxReturn",
      component: TaxReturn,
      meta: {
        requiresAuth: true,
        menuId: "040500"
      }
    },
    {
      path: "/monthlyLeaveBalance",
      name: "MonthlyLeaveBalance",
      component: MonthlyLeaveBalance,
      meta: {
        requiresAuth: true,
        menuId: "040300"
      }
    },
    {
      path: "/employees",
      name: "EmployeeList",
      component: EmployeeList,
      meta: {
        requiresAuth: true,
        menuId: "040301"
      }
    },
    {
      path: "/setup",
      name: "SetupPage",
      component: SetupPage,
      meta: {
        requiresAuth: true,
        menuId: "080000"
      }
    },
    {
      path: "/job",
      name: "JobAds",
      component: JobAds,
      meta: {
        requiresAuth: true,
        menuId: "S090100"
      }
    },
    {
      path: "/InviteNewCandidate",
      name: "InviteNewCandidate",
      component: InviteNewCandidate,
      meta: {
        requiresAuth: true,
        menuId: "040304"
      }
    },
    {
      path: "/JobApplicationForm",
      name: "JobApplicationForm",
      component: JobApplicationForm,
      meta: {
        requiresAuth: true,
        menuId: "040305"
      }
    },
    {
      path: "/Enquiry",
      name: "Enquiry",
      component: Enquiry,
      meta: {
        requiresAuth: true,
        menuId: "040306"
      }
    },
    {
      path: "/Calendar",
      name: "Calendar",
      component: Calendar,
      meta: {
        requiresAuth: true,
        menuId: "040306"
      }
    },
    {
      path: "/InterviewSchedule",
      name: "InterviewSchedule",
      component: InterviewSchedule,
      meta: {
        requiresAuth: true,
        menuId: "040306"
      }
    },
    {
      path: "/InterviewScheduleNew",
      name: "InterviewScheduleNew",
      component: InterviewScheduleNew,
      meta: {
        requiresAuth: true,
        menuId: "040306"
      }
    },
    {
      path: "*",
      name: "404",
      component: Login,
      meta: { loginauth: true }
    },
    {
      path: "/verify",
      name: "Verify",
      component: VerifyCandidate,
      meta: { requiresAuth: false }
    },
    {
      path: "/jobapplication/:candId",
      name: "JobApplication",
      component: JobApplication,
      meta: { requiresAuth: false }
    },
    {
      path: "/candidateJobApplicationForm/:candId",
      name: "CandidateJobApplicationForm",
      component: CandidateJobApplicationForm,
      meta: { requiresAuth: true }
    },
    {
      path: "/CandidateJobInterviewStart",
      name: "CandidateJobInterviewStart",
      component: CandidateJobInterviewStart,
      meta: { requiresAuth: true }
    },
    {
      path: "/InterviewStart",
      name: "InterviewStart",
      component: JobInterviewStart,
      meta: {
        requiresAuth: true,
        menuId: "S090300"
      }
    },
    {
      path: "/payrollTrial",
      name: "payrollTrial",
      component: PayrollTrial,
      meta: {
        requiresAuth: true,
        menuId: Settings.MenuID.PayrollTrial
      }
    },
    {
      path: "/specialPayment",
      name: "specialPayment",
      component: SpecialPayment,
      meta: {
        requiresAuth: true,
        menuId: Settings.MenuID.SpecialPayment
      }
    },
    {
      path: "/payrollAdjustment",
      name: "payrollAdjustment",
      component: PayrollAdjustment,
      meta: {
        requiresAuth: true,
        menuId: Settings.MenuID.PayrollAdjustment
      }
    },
    {
      path: "/payrollApproval",
      name: "payrollApproval",
      component: PayrollApproval,
      meta: {
        requiresAuth: true,
        menuId: Settings.MenuID.PayrollApproval
      }
    },
    {
      path: "/finalPayment",
      name: "finalPayment",
      component: FinalPayment,
      meta: {
        requiresAuth: true,
        menuId: Settings.MenuID.FinalPayment
      }
    },
    {
      path: "/payProfile",
      name: "payProfile",
      component: PayProfile,
      meta: {
        requiresAuth: true,
        menuId: Settings.MenuID.PayProfile
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters[StoreGetter.user]) {
      next({
        path: "/",
        params: { nextUrl: to.fullPath }
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.loginauth)) {
    if (store.getters[StoreGetter.user]) {
      next({
        path: "/approval",
        params: { nextUrl: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js